import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavBar, { NavBarItem } from "../../../components/NavBar";
import "./PrototypeShared.css";

interface ClienteScore {
  nome: string;
  score: number; // 0-100
  leadTimeMedio: number;
  pendenciaDocumental: number; // %
  emailsComFalha: number;
}

const clientes: ClienteScore[] = [
  { nome: "GE Celma Matriz", score: 91, leadTimeMedio: 7.4, pendenciaDocumental: 22, emailsComFalha: 0 },
  { nome: "GE Power & Water", score: 78, leadTimeMedio: 9.1, pendenciaDocumental: 35, emailsComFalha: 1 },
  { nome: "Motoman", score: 64, leadTimeMedio: 12.8, pendenciaDocumental: 48, emailsComFalha: 2 },
  { nome: "Baker Hughes", score: 52, leadTimeMedio: 15.2, pendenciaDocumental: 51, emailsComFalha: 3 },
];

const corDoScore = (score: number) => {
  if (score >= 80) return { cor: "var(--ok)", pill: "proto-pill-ok", texto: "Saudável" };
  if (score >= 60) return { cor: "var(--pending)", pill: "proto-pill-warn", texto: "Atenção" };
  return { cor: "var(--danger)", pill: "proto-pill-danger", texto: "Risco" };
};

/**
 * Protótipo da aposta 5: score de saúde do cliente. Cruza lead time de liberação,
 * pendência documental e sucesso de e-mail — os três já calculados de verdade no
 * Painel Executivo, só que hoje agregados pra empresa toda, não por cliente. Sem
 * lógica de negócio nova.
 */
const ScoreClienteView: React.FC = () => {
  const navItems: NavBarItem[] = [
    { label: "Início", route: "/", iconName: "house-door" },
    { label: "Iniciativas", route: "/iniciativas-estrategicas", iconName: "compass" },
  ];

  return (
    <Container fluid>
      <NavBar items={navItems} />
      <div className="mb-2"></div>

      <div className="proto-wrap">
        <Link to="/iniciativas-estrategicas" className="proto-back">← Iniciativas estratégicas</Link>

        <div className="proto-header">
          <div className="proto-badge">🧭 Protótipo — aposta 5 de 5</div>
          <h2>Score de saúde do cliente</h2>
          <p className="proto-subtitle">
            Cruza pendência documental, lead time de liberação e falhas de e-mail por cliente — aponta quem está
            tendo experiência ruim antes dele simplesmente parar de mandar carga.
          </p>
        </div>

        <div className="proto-section-title">Clientes monitorados</div>
        <div className="proto-cards">
          {clientes.map((c) => {
            const s = corDoScore(c.score);
            return (
              <div className="proto-card" key={c.nome}>
                <div className="proto-card-top">
                  <span className="proto-card-name">{c.nome}</span>
                  <span className={`proto-pill ${s.pill}`}>{s.texto}</span>
                </div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 4 }}>
                  <span style={{ fontSize: 22, fontWeight: 700, color: s.cor }}>{c.score}</span>
                  <span style={{ fontSize: 11, color: "var(--sub)" }}>/ 100</span>
                </div>
                <div className="proto-bar-track">
                  <div className="proto-bar-fill" style={{ width: `${c.score}%`, background: s.cor }}></div>
                </div>
                <div className="proto-card-row"><span>Lead time médio</span><b>{c.leadTimeMedio.toFixed(1)} dias</b></div>
                <div className="proto-card-row"><span>Pendência documental</span><b>{c.pendenciaDocumental}%</b></div>
                <div className="proto-card-row"><span>E-mails com falha</span><b>{c.emailsComFalha}</b></div>
              </div>
            );
          })}
        </div>

        <div className="proto-note">
          Dados ilustrativos. Fontes reais: lead time e pendência documental por Release, sucesso de e-mail por
          EmailLog — os três já existem, agregados por empresa toda, no Painel Executivo (KPIs 01, 05 e 10).
        </div>

        <div className="proto-footer-nav">
          <Link to="/iniciativas-estrategicas/otimizacao-frete">← Otimização de frete</Link>
          <Link to="/painel-executivo">Ver Painel Executivo →</Link>
        </div>
      </div>
    </Container>
  );
};

export default ScoreClienteView;
